import { render, staticRenderFns } from "./email-info.vue?vue&type=template&id=5ad9533e&scoped=true"
import script from "./email-info.vue?vue&type=script&lang=ts"
export * from "./email-info.vue?vue&type=script&lang=ts"
import style0 from "./email-info.vue?vue&type=style&index=0&id=5ad9533e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad9533e",
  null
  
)

export default component.exports